var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24539_151138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8132 4L12.6413 4C12.5617 4 12.4867 4.03906 12.4398 4.10313L8.0007 10.2219L3.56163 4.10313C3.51475 4.03906 3.43975 4 3.36006 4L2.18819 4C2.08662 4 2.02725 4.11563 2.08662 4.19844L7.59601 11.7938C7.79601 12.0688 8.20539 12.0688 8.40383 11.7938L13.9132 4.19844C13.9742 4.11563 13.9148 4 13.8132 4Z",
    fill: "#2C4652",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24539_151138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16) rotate(-180)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-down.6bded429.svg";
export { ForwardRef as ReactComponent };